import { styled } from "styled-components";

import { getLevelStyles } from "@/components/Achievements/utils";

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 1.5rem 1rem;

  & > button {
    margin-top: 0.25rem;
  }
`;

const Level = styled.div<{ $completed: boolean; $level: number }>`
  position: relative;

  display: flex;
  align-self: center;
  gap: 0.75rem;

  & > svg {
    ${({ $level, $completed }) => getLevelStyles($completed ? $level : "disabled")}
    z-index: 10;
  }
  & > span {
    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    color: ${({ theme }) => theme.colors.black};
    font-size: 0.81531rem;
    font-weight: 500;
    z-index: 11;
  }
`;

export default {
  Container,
  Level,
};
